module.exports = __webpack_public_path__ + "static/media/flag-italy.ebc8338c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/shared/LanguageFlag/LanguageFlagIcons/flag-italy.svg
// module id = 1130
// module chunks = 1